// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__nPrMU","window":"Modal_window__Wb4Dl","title":"Modal_title__yAh0h","close":"Modal_close__Yp33c"};